import { get } from "@ember/object"
import Service, { inject as service } from "@ember/service"
import analytics from "./callbacks/action/analytics"
import log from "./callbacks/action/log"

export default class ActionCallbacksService extends Service {
  @service("ember-store") store
  @service session
  @service rpc
  @service finder

  init() {
    super.init(...arguments)

    let actionStream = Kefir.fromEvents(
      get(this, "store"),
      "action",
      (actionName, payload, actionDoc) => {
        return [actionName, payload, actionDoc]
      }
    )

    log.call(this, actionStream)
    analytics.call(this, actionStream, this.session)
  }
}
